import { rawIfc } from '@viewer/lib/rawIfc'

/** O que cada elemento espacial referencia (IfcRelReferencedInSpatialStructure),
 *  lido do IFC em bruto.
 *
 *  Uma IfcSpatialZone (compartimento corta-fogo, zona térmica) não
 *  contém elementos: referencia-os. O navegador lógico só contava a
 *  contenção, e todas as zonas apareciam com 0. */

const cache = new Map<string, { modelID: number; mapa: Map<number, number[]> }>()

function idDe(ref: unknown): number | null {
  if (typeof ref === 'number') return Number.isFinite(ref) ? ref : null
  if (!ref || typeof ref !== 'object') return null
  const o = ref as { value?: unknown; expressID?: unknown }
  if (typeof o.value === 'number') return o.value
  if (typeof o.expressID === 'number') return o.expressID
  return null
}

/** Por elemento espacial (expressID): os elementos que referencia. */
export function referenciasDoModelo(modelId: string): Map<number, number[]> {
  const h = rawIfc.getRawHandles(modelId)
  if (!h) return new Map()
  const c = cache.get(modelId)
  if (c && c.modelID === h.modelID) return c.mapa
  const mapa = new Map<number, number[]>()
  for (const relId of rawIfc.getLineIDsByType(modelId, 'IFCRELREFERENCEDINSPATIALSTRUCTURE')) {
    let linha: Record<string, unknown> | null
    try {
      linha = h.api.GetLine(h.modelID, relId, false, false) as Record<string, unknown> | null
    } catch {
      continue
    }
    const pai = idDe(linha?.RelatingStructure)
    const elems = linha?.RelatedElements
    if (pai === null || !Array.isArray(elems)) continue
    const lista = mapa.get(pai) ?? []
    for (const e of elems) {
      const id = idDe(e)
      if (id !== null) lista.push(id)
    }
    mapa.set(pai, lista)
  }
  cache.set(modelId, { modelID: h.modelID, mapa })
  return mapa
}

/** O que está num elemento espacial: o que contém e o que referencia,
 *  sem repetidos. */
export function conteudoEspacial(modelId: string, id: number): number[] {
  const contidos = rawIfc.getContainedElements(modelId, id)
  const refs = referenciasDoModelo(modelId).get(id) ?? []
  return [...new Set([...contidos, ...refs])]
}
